import React from "react";
import PropTypes from "prop-types";
import koenigsErlaeuterungen from '../../assets/images/KE_logo.jpg'
import iconFB from '../../assets/images/fb.png'
import iconInsta from '../../assets/images/instagram.png'
import iconYoutube from '../../assets/images/youtube.png'
import {isMobile} from "../../utils/device";
import './mainFooter.css'

import {useSelector} from 'react-redux'

const MainFooter = ({copyright, transparent, transparentMobile}) => {

    const authentication = useSelector((state) => state.authentication);

    // https://de.pons.com/p/kontakt
    return (
        <footer id={transparentMobile || transparent ? "mainFooterTransparent" : "mainFooter"}
                className="container-fluid"
                style={{}}>
            <div style={{paddingTop: 10, paddingBottom: 20, paddingLeft: 30, paddingRight: 30, minHeight:200}}
                 className="row footer-container">
                <div className="links-section col-md-3 col-6">
                    <div className={"footerMenuItem"}>
                        <a href="/alle-arbeitshilfen/">
                            <span className={"footerMenuItem"}>Alle Arbeitshilfen</span>
                        </a>
                    </div>
                    <div className="footerMenuItem">
                        <a href="https://lektueren-verstehen.de/infothek/kontakt/">
                            <span className={"footerMenuItem"}>Kontakt</span>
                        </a>
                    </div>
                    <div className="footerMenuItem">
                        <a href="https://lektueren-verstehen.de/infothek/der-verlag/">
                            <span className={"footerMenuItem"}>&Uuml;ber uns</span>
                        </a>
                    </div>
                </div>
                <div className="links-section col-md-3 col-6">
                    <div className={"footerMenuItem"}>
                        <a href="https://lektueren-verstehen.de/infothek/faq/">
                            <span className={"footerMenuItem"}>FAQs</span>
                        </a>
                    </div>
                  <div className={"footerMenuItem"}>
                    <a href="https://lektueren-verstehen.de/infothek/barrierefreiheit/">
                      <span className={"footerMenuItem"}>Barrierefreiheit</span>
                    </a>
                  </div>

                </div>
                <div className="links-section col-md-3 col-6">
                    <div className="footerMenuItem">
                        <a href="https://de.pons.com/p/impressum">
                            <span className={"footerMenuItem"}>Impressum</span>
                        </a>
                    </div>

                    <div className="footerMenuItem">
                        <a href="https://de.pons.com/p/datenschutz">
                            <span className={"footerMenuItem"}>Datenschutz</span>
                        </a>
                    </div>
                    <div className="footerMenuItem">
                        <a href="https://de.pons.com/p/agb/">
                            <span className={"footerMenuItem"}>AGB</span>
                        </a>
                    </div>
                </div>
                <div className="links-section col-md-3">
                    <div className={"row footerMenuItem"}>
                        <div className="col-12 text-right mt-2">
                            <a href="https://www.koenigs-erlaeuterungen.de/" target="blank">
                                <img alt="koenigsErlaeuterungen" src={koenigsErlaeuterungen}
                                     style={{maxWidth: "200px"}}/>
                            </a>
                            <div style={{color: "lightgrey"}}>{copyright}</div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}


MainFooter.propTypes = {
    /**
     * Whether the content is contained, or not.
     */
    contained: PropTypes.bool,
    /**
     * The menu items array.
     */
    menuItems: PropTypes.array,
    /**
     * The copyright info.
     */
    copyright: PropTypes.string
};
const currentyear = new Date().getFullYear();
MainFooter.defaultProps = {
    contained: false,
    copyright: "© " + currentyear + " PONS Langenscheidt GmbH"
};

export default MainFooter;
